import { render, staticRenderFns } from "./Category.vue?vue&type=template&id=fac554b8&scoped=true"
import script from "./Category.vue?vue&type=script&lang=ts"
export * from "./Category.vue?vue&type=script&lang=ts"
import style0 from "./Category.vue?vue&type=style&index=0&id=fac554b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fac554b8",
  null
  
)

export default component.exports